import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addMessage, clearState, fetchMessagesList, submitAnswer } from '../../../reducers/messageSlice';
import { sendRequestAsync } from "../../../api/requestService";
import { baseUrl, requestStatus, httpMethod, markAnswerAsReadUrl } from '../../../api/apiConsts';
import { changeLoadingStatus } from '../../../reducers/loadingSlice';
import Image from '../Image/index';
import messageAudioNotification from '../../../static/sounds/pop-ding-notification-effect-4.mp3';

let signalRConnection = null;

export default function Chat() {
    const credentials = useSelector(state => state.message.credentials);
    const chat = useSelector(state => state.message.chat);
    const fetchStatus = useSelector(state => state.message.status);
    const isLoading = useSelector(state => state.loading.isLoading);
    const dispatch = useDispatch();
    const [newAnswer, setNewAnswer] = useState("");

    const onSendClick = () => {
        if (!newAnswer) {
            return;
        }
        dispatch(submitAnswer({ answerText: newAnswer }));
        setNewAnswer("");
    }

    const cleanup = () => {
        signalRConnection?.stop();
        signalRConnection = null;
        dispatch(clearState());
    }

    useEffect(() => {
        if (credentials?.number && (!chat || credentials?.number !== `${chat?.ReportId}`)) {
            dispatch(fetchMessagesList(credentials));
        }

        return () => cleanup()
    }, [credentials])

    useEffect(() => {
        if (chat && !signalRConnection && window.signalR) {      
            const signalR = window.signalR;
            const connUrl = baseUrl + "/reportanswershub?reportid=" + (chat?.ReportId || credentials?.number);
            signalRConnection = new signalR.HubConnectionBuilder()
                .withUrl(connUrl)
                .build();

            signalRConnection.on('addMessage', 
                (answerString) => {
                    if (answerString) {
                        dispatch(addMessage(JSON.parse(answerString)))
                        dispatch(fetchMessagesList(credentials))
                        document.getElementById('message-audio-notification').play()
                    }
                }
            );

            signalRConnection?.start();
        }

        if (chat?.Answers?.length > 0) {
            const lastAnswerElement = document.getElementById(`message__item_${chat.Answers[chat.Answers.length - 1].AnswerId}`);
            if (lastAnswerElement) {
                lastAnswerElement.scrollIntoView()
            }

            sendRequestAsync(httpMethod.post, markAnswerAsReadUrl, { reportId: credentials?.number || chat?.ReportId  });
        }
    }, [chat])

    useEffect(() => {
        const isFetching = fetchStatus === requestStatus.loading;
        if (isLoading !== isFetching) {
            dispatch(changeLoadingStatus(isFetching));
        }
    }, [fetchStatus])

    return chat && (
        <>
            <audio id="message-audio-notification" controls="controls" autostart="false" style={{display: "none"}}>
                <source src={messageAudioNotification} type="audio/mpeg" />
            </audio>

            <div className="container chat__container">
                {chat?.Answers?.length
                    ? chat.Answers.map(answer => (
                        <div className="message__item" id={`message__item_${answer.AnswerId}`} key={answer.AnswerId}>
                            <div className="message__time">{answer.AnsweredAt}</div>
                            <div className={answer.AnswerSource === 0 ? "message__wrapper_location" : "message__wrapper_user"}>
                                {answer.AnswerSource === 0 && chat.LocationLogo
                                    && <Image className="message__location-logo" src={chat.LocationLogo} />}
                                <div className="text_default message__text">
                                    {answer.AnswerText} 
                                    {answer.IsLinkIncluded && <div><a href={answer.Link} className="message__link">{answer.LinkText}</a></div>}
                                </div>
                            </div>
                        </div>
                    ))
                    : <div className="section__header">No messages yet</div>}
            </div>

            {chat?.AllowAnswerFromClient &&
                <div className="input__container chat__input__container">
                    <input
                        value={newAnswer}
                        onInput={e => setNewAnswer(e.target.value)}
                        className="text_default chat__input"
                        placeholder="Your reply..."
                    />
                    <div className="chat__button" onClick={() => onSendClick()}>Send</div>
                </div>
            }
        </>
    )
}